import type { NotificationProvider } from '@refinedev/core';
import { notification } from 'antd';

const notificationProvider: NotificationProvider = {
  open: ({ message, description, type }) => {
    if (type === 'error') {
      if (description?.includes('_global-notified')) {
        return;
      }
      return notification.error({
        message,
        description
      });
    }

    notification.success({
      message,
      description
    });
  },
  close: () => {
    notification.destroy();
  }
};

export default notificationProvider;
